import { Tag } from "antd";
import { deviceTypeOptions } from "@/utils/enums";

export const rewardDetailColumns = [
  {
    title: "资金走向类型",
    dataIndex: "accountTrendStr",
    key: "accountTrendStr",
    render: (val: string) => (
      <Tag color={val === "消耗" || val === "支出" || val === "消耗/支出" ? "green" : "blue"}>{val}</Tag>
    )
  },
  {
    title: "金额",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "手机号",
    dataIndex: "mobile",
    key: "mobile",
  },
  {
    title: "分润类型",
    dataIndex: "businessTypeStr",
    key: "businessTypeStr",
  },
  // {
  //   title: "分润类型",
  //   dataIndex: "businessTypeStr",
  //   key: "businessTypeStr",
  // },
  {
    title: "用户名/运营中心名称",
    dataIndex: "nickName",
    key: "nickName",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
];

/** 支付详情弹窗表格列 */
export const payDetailColumns = [
  { title: "支付类型", dataIndex: "payAmountTypeStr", key: "payAmountTypeStr" },
  { title: "支付金额", dataIndex: "payAmount", key: "payAmount" },
  { title: "服务费", dataIndex: "serviceCharge", key: "serviceCharge" },
  { title: "备注", dataIndex: "remark", key: "remark" },
  { title: "创建时间", dataIndex: "createTime", key: "createTime" },
];

export const formTab = [
  {
    label: "订单号",
    name: "orderId",
    type: "input",
    // width: "340px",
  },
  {
    label: "产品名称",
    name: "productName",
    type: "input",
  },
  
  {
    label: "用户账号",
    name: "mobile",
    type: "input",
  },
  {
    label: "团队属性",
    name: "teamAttribute",
    type: "input",
  },
  {
    label: "用户Id",
    name: "userId",
    type: "input",
  },
  {
    label: "设备类型",
    name: "productType",
    type: "select",
    options: deviceTypeOptions
  },
  {
    label: "订单状态",
    name: "orderStatus",
    type: "select",
    options: [
      { label: "已支付", value: "0" },
      { label: "退款", value: "1" },
    ]
  },
  {
    label: "时间范围",
    name: "rangePicker",
    type: "rangePicker",
    width: "380px",
  },
];